"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _createGenerateClassName.default;
  }
});

var _createGenerateClassName = _interopRequireDefault(require("./createGenerateClassName"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/styles/createGenerateClassName/index.js
 ** module id = 128
 ** module chunks = 0
 **/